import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Form, Formik } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { LivingSituationStepForm } from './LivingSituationStepForm';
import { livingSituationSchema } from '../../schema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LivingSituationStep(): ReactElement {
  const dispatch = useDispatch();
  const { livingSituation: livingSituation } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('living_situation');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <CardPadding>
      <CardHeader
        header="What's your living situation?"
        subHeader="This determines your need for one type of coverage."
      />
      <Formik
        initialValues={{ livingSituation }}
        onSubmit={onSubmit}
        validationSchema={livingSituationSchema}
      >
        <Form ref={formRef}>
          <LivingSituationStepForm />
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { LivingSituationStep };
